import { Imagen } from "./domain/imagen";

export const GLOBAL = {

  // URL_BASE: 'http://127.0.0.1:8081/sigamos-cart-web/rest/controllers/',
  // URL_SIGAMOS: 'http://127.0.0.1:8080/repuestos-services/controller/',
  // URL_BASE_SENTINEL: 'http://127.0.0.1:8080/sentinel-web/controller/sigamosServices/',

  URL_BASE: 'https://herorepuestos.com/sigamos-cart-web/rest/controllers/',
  URL_SIGAMOS: 'https://sso.herodatapro.com/repuestos-services/controller/', 
  URL_BASE_SENTINEL: 'https://sso.herodatapro.com/sentinel-web/controller/sigamosServices/',

  CODIGO_CEDULA_CIUDADANIA: 'CC',
  CODIGO_CEDULA_EXTRANJERIA: 'CE',
  CODIGO_NIT: 'NI',
  ID_CEDULA_CIUDADANIA: 1,
  ID_CEDULA_EXTRANJERIA: 2,
  ID_NIT: 3,

  IDENTIFICACIONES: [
    { id: 1, codigo: 'CC', descripcion: 'CÉDULA DE CIUDADANÍA'},
    { id: 2, codigo: 'CE', descripcion: 'CÉDULA DE EXTRANJERÍA'},
    { id: 3, codigo: 'NI', descripcion: 'NIT'}
  ],

  ESTADOS_CUPON:[
    { codigo: 'VI', descripcion: 'VIGENTE' },
    { codigo: 'AS', descripcion: 'ASIGNADO' },
    { codigo: 'LE', descripcion: 'LEGALIZADO' },
    { codigo: 'VE', descripcion: 'VENCIDO' },
    { codigo: 'CA', descripcion: 'CANCELADO'}
  ],
  CODIGO_TIPO_TERCERO_NATURAL: 'NAT',
  CODIGO_TIPO_TERCERO_JURIDICA: 'JUR',
  ID_TIPO_TERCERO_NATURAL: 1,
  ID_TIPO_TERCERO_JURIDICA: 2,

  CODIGOS_SEXO: [
    { codigo: 'M', descripcion: 'FEMENINO' },
    { codigo: 'H', descripcion: 'MASCULINO' },
    { codigo: 'N', descripcion: 'NO DESEO MANIFESTARLO' }
  ],
  CODIGOS_ORDEN:[
    { codigo: '1', descripcion: '1' },
    { codigo: '2', descripcion: '2' },
    { codigo: '3', descripcion: '3' },
    { codigo: '4', descripcion: '4' },
    { codigo: '5', descripcion: '5' },
    { codigo: '6', descripcion: '6' },
  ],

  FORMATO_FECHAS:'yyyy-MM-dd',
  
  ESTADO_ACTIVO: 'A',
  ESTADO_INACTIVO: 'I',
  SI: 'S',
  NO: 'N',

  CODIGO_MAX_BANNERS:'MAX_BANNERS',
  ACTUALIZAR:'Actualizar',
  GUARDAR_NUEVO:'Crear',

  NOMBRE_BUCKET: 'hero-cart-produccion',
  REGION_S3: 'us-east-1',
  CODIGO_RUTA_S3:'CODIGO_RUTA_S3',
  BUCKET_BANNERS:'banners',
  BUCKET_NOVEDADES:'novedades',
  BUG_ERROR_S3: 'SignatureDoesNotMatch',

  HTTP_OK: '200',
  HTTP_BAD_REQUEST: '400',
  HTTP_NOT_FOUND: '404',

  TIPOS_DIRECCIONES: [
    'Calle', 
    'Carrera', 
    'Avenida', 
    'Avenida Carrera',
    'Circular',
    'Circunvalar',
    'Diagonal',
    'Manzana',
    'Transversal'
  ],

  CODIGO_ESTADO_NOVEDAD_ABIERTA:'A',
  MENSAJE_AGREGAR_ADJUNTO_NOVEDAD:' --Archivo adjunto: ',

  //ROLES
  ROL_USUARIO_FINAL: 'USUARIO',
  ROL_COMERCIAL: 'COMERCIAL',
  ROL_SERVICIO_CLIENTE: 'SERVICIO_CLIENTE',
  ROL_ADMIN_TI: 'ADMINISTRADOR_TI',
  ROL_ADMIN: 'ADMIN',
  REPORTE_PARTES_MAS_VENDIDAS: '1',
  REPORTE_PARTES_MENOS_VENDIDAS: '2',
  
  //RUTA BUCKET
  URL_BUCKET: 'https://s3.amazonaws.com/hero-partes/',
  IMAGEN_DEFECTO: new Imagen('IMAGENES/DEFAULT/SMALL.JPG', 'IMAGENES/DEFAULT/MEDIUM.JPG', 'IMAGENES/DEFAULT/BIG.JPG'),
  CODIGO_TIPO_NOVEDAD_REEMBOLSO: 4,

  LOCALSTORAGE_SIGAMOSCARTTOKEN: 'sigamosCartToken',
  LOCALSTORAGE_CARTLIST: 'cartList',
  LOCALSTORAGE_CARTLISTNOLOGIN: 'cartListNoLogin',
  LOCALSTORAGE_EMAILTMP: 'emailTmp',

  NO_PROVIDER_MESSAGE: 'No fué posible estalecer una conexión con el servicio',
  
  PARAMETRO_MENSAJE_NOVEDAD: 'MENSAJE_NOVEDAD',
  PARAMETRO_MENSAJE_CHECKOUT: 'MENSAJE_CHECKOUT',
  ORDEN_BUSQUEDA : [
    {codigo: 'DEFAULT', descripcion: 'Ordenar por defecto'},
    {codigo: 'NEW', descripcion: 'Nuevos'},
    {codigo: 'LOW_PRICE', descripcion: 'Menor precio'},
    {codigo: 'HIGH_PRICE', descripcion: 'Mayor precio'}
  ],

  PARAMETRO_MENSAJE_CERRAR_NOVEDAD: 'MENSAJE_CERRAR_NOVEDAD',
  RUTA_BUCKET_CATEGORIAS: 'RUTA_BUCKET_CATEGORIAS',
  
  BUCKET_SECRET_KEY: 'SECRET_KEY_AWS',
  BUCKET_SECRET_ID: 'SECRET_ID_AWS',

  PARAMETRO_ESTADO_IFRAE_HOME : 'ESTADO_IFRAME_HOME',

};